import { inject, computed } from 'vue';

export default function useLocate() {
  const { locale } = useI18n()
  const getConfigJson = inject('getConfigJson', () => ({}));
  const getCommonConfigJson = inject('getCommonConfigJson', () => ({}));
  const setLangJsonConfigMap = inject('setLangJsonConfigMap', () => {});

  const langJson = computed(() => {
    let res={};
    if(getCommonConfigJson && typeof getCommonConfigJson === 'function' ){
      Object.assign(
        res,
        getCommonConfigJson().langJson
      )
    }
    if(getConfigJson && typeof getConfigJson === 'function' ){
      Object.assign(
        res,
        getConfigJson().langJson
      )
    }
    
    return res;
  });
 
  const langCodeProxyMap = {
    "zh-CN":"hans",
    "zh-Hans":"hans",
    "zh":"hans",
    "zh-TW":"zh-Hant",
    "zh-Hant":"zh-Hant",
    "tw":"zh-Hant",
    "vi_VN":"vi",
    "vi":"vi",
    "ja_JP":"ja",
    "ja":"ja",
    "en":"en",
    "th_TH":"th_TH",
    "ms_MY":"ms_MY",
  }
  const nowLocale = computed(() => {
    let res='hans';
    
    if(locale.value&&langCodeProxyMap[locale.value]){
      res=langCodeProxyMap[locale.value];
    }
    return res;
  });

  const getLocaleText = (text) => {
    
    if (process.client&&typeof setLangJsonConfigMap === 'function' && text) {
       
      setLangJsonConfigMap(text);
    }
    return langJson.value[text] && langJson.value[text][nowLocale.value] ? langJson.value[text][nowLocale.value] : text;
  };

  return {
    langJson,
    nowLocale,
    getLocaleText,
  };
}
